import React, { useEffect } from "react";
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import ColumnChart from 'components/Cards/ColumnChart';
import Footer from 'components/Footers/Footer';
import Navbar from 'components/Navbars/AdminNavbar';
import CardStatsForAdmin from "components/Cards/CardStatsForAdmin";
import HeaderStatsForAdmin from "components/Headers/HeaderStatsForAdmin";
import ColumnChartForAdmin from "components/Cards/ColumnChartForAdmin";

// Rename the component to start with an uppercase letter
const AdminDashboard = () => {
    const history = useHistory();

    useEffect(() => {
        // Check if the user is not logged in (localStorage is empty)
        if (!localStorage.getItem("userData")) {
            // Redirect to the login page
            history.push("/login");
        }
    }, [history]);

    return (
        <>
            <Navbar />
            <HeaderStatsForAdmin/>
            <div className='cust-div'>
                {/* <div className="flex flex-wrap mb-3">
                    <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                        <CardStatsForAdmin />
                    </div>
                </div> */}
              
                <div className="flex flex-wrap mt-4 ">
                    <div className="w-full xl:w-12/12 mb-12 xl:mb-0 px-4">
                        <ColumnChartForAdmin />
                    </div>        
                </div>
            </div>
            <Footer />
        </>
    );
};

export default AdminDashboard;
